import { Link } from "@tanstack/react-router";
import { Facebook, Instagram, Send, Mail, Phone } from "lucide-react";
import { CONTACT, mailLink, telLink } from "@/lib/contact";

export function SiteFooter() {
  return (
    <footer className="mt-12 border-t border-border bg-secondary text-secondary-foreground md:mt-20">
      <div className="container-x grid gap-8 py-10 sm:grid-cols-2 md:grid-cols-4 md:gap-10 md:py-14">
        <div className="sm:col-span-2 md:col-span-1">
          <span className="text-2xl font-extrabold tracking-tight">
            Albazar<span className="text-premium">.az</span>
          </span>
          <p className="mt-3 max-w-xs text-sm opacity-95">
            Azərbaycanın müasir elan platforması. Al, sat, kirayələ — sürətli və təhlükəsiz.
          </p>
          <div className="mt-5 flex gap-2">
            {[
              { icon: Facebook, label: "Facebook" },
              { icon: Instagram, label: "Instagram" },
              { icon: Send, label: "Telegram" },
            ].map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                className="grid size-10 place-items-center rounded-full bg-primary/15 text-primary transition-transform hover:scale-110 hover:bg-primary hover:text-primary-foreground"
              >
                <Icon className="size-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold uppercase tracking-wide">Şirkət</h3>
          <ul className="space-y-2 text-sm opacity-80">
            <li><Link to="/haqqimizda" className="hover:text-primary">Haqqımızda</Link></li>
            <li><Link to="/faq" className="hover:text-primary">Tez-tez verilən suallar</Link></li>
            <li><Link to="/mexfilik" className="hover:text-primary">Məxfilik siyasəti</Link></li>
            <li><Link to="/sertler" className="hover:text-primary">İstifadə şərtləri</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold uppercase tracking-wide">İstifadəçi</h3>
          <ul className="space-y-2 text-sm opacity-80">
            <li><Link to="/giris" className="hover:text-primary">Giriş</Link></li>
            <li><Link to="/qeydiyyat" className="hover:text-primary">Qeydiyyat</Link></li>
            <li><Link to="/profil" className="hover:text-primary">Profil</Link></li>
            <li><Link to="/yeni-elan" className="hover:text-primary">Elan yerləşdir</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold uppercase tracking-wide">Əlaqə</h3>
          <ul className="space-y-3 text-sm opacity-80">
            <li>
              <a href={mailLink} className="flex items-center gap-2 hover:text-primary">
                <Mail className="size-4 shrink-0 text-primary" />
                <span className="truncate">{CONTACT.email}</span>
              </a>
            </li>
            <li>
              <a href={telLink} className="flex items-center gap-2 hover:text-primary">
                <Phone className="size-4 shrink-0 text-primary" />
                <span>{CONTACT.phoneLabel}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs opacity-95">
        © 2026 Albazar.az — Bütün hüquqlar qorunur.
      </div>
    </footer>
  );
}